import axios from 'axios';
import { API_BASE_URL } from '../environment';
import { setupInterceptors } from './interceptor';

const BASE_URL = API_BASE_URL || 'http://localhost:3000';

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 160000,
});

setupInterceptors(apiClient);

const withAbort = requestFn => {
  const controller = new AbortController();
  const promise = requestFn(controller.signal);
  promise.abort = () => controller.abort();
  return promise;
};

export const client = {
  get: (url, config = {}) =>
    withAbort(signal => apiClient.get(url, { ...config, signal })),

  post: (url, data, config = {}) =>
    withAbort(signal => apiClient.post(url, data, { ...config, signal })),

  put: (url, data, config = {}) =>
    withAbort(signal => apiClient.put(url, data, { ...config, signal })),

  delete: (url, config = {}) =>
    withAbort(signal => apiClient.delete(url, { ...config, signal })),
};
